import React, { useEffect, useCallback, useState, useRef } from 'react';
import PropTypes, { any } from 'prop-types';
import dynamic from 'next/dynamic';
import {
  Row,
  Col,
  Collapse,
  Spin,
  Icon,
  Select,
  Input,
  Button,
  Form
} from 'antd';
import { StyledDemonstration } from '../../styled-components/product/product-demonstration';
import UploadImg2base64 from './UploadImg2base64';
import CanvasDrawer from './CanvasDrawer/CanvasDrawer';
import account from '@/common/account/index';

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const { Panel } = Collapse;
const { Option } = Select;
const ReactJson = dynamic(import('react-json-view'), { ssr: false });

const OcrCCDemonstration = ({
  response,
  request,
  result,
  materialsPath = [],
  selectList = [],
  handleIdentifyingImg,
  changeLocationInfo,
  noUpload,
  inputOption = {},
  initInfo = {},
  location = [],
  form = any,
  lang
}) => {
  const formCanvas = useRef(null);
  const [spinning, setSpinning] = useState(false);
  const [imgDom, setImgDom] = useState(null);
  const [activeSelectIndex, setActiveSelectIndex] = useState(initInfo.classId);
  const [inputText, setInputText] = useState(initInfo.title);
  const [imgUrl] = useState(materialsPath[0]);
  const [imgData, setImgData] = useState();
  const { getFieldDecorator } = form;
  const { validateFields } = form;
  const { setFieldsValue } = form;

  const params = useCallback(() => {
    let userId = null;
    const loginEd = account.hasLoggedin();
    if (loginEd) userId = localStorage.getItem('userId') || null;
    if (imgData) {
      return lang === 'cn'
        ? {
            grade: activeSelectIndex,
            title: inputText,
            answer_base64: [imgData.replace(/\S*base64,/, '')],
            method: '/aitext/ch-composition/text-correction',
            userId
          }
        : {
            image_base64: [imgData.replace(/\S*base64,/, '')],
            method: '/aitext/english-composition/text-correction',
            userId
          };
    } else {
      return lang === 'cn'
        ? {
            grade: activeSelectIndex,
            title: inputText,
            answer_url: [imgUrl],
            method: '/aitext/ch-composition/text-correction',
            userId
          }
        : {
            grade: activeSelectIndex,
            image_url: [imgUrl],
            method: '/aitext/english-composition/revise',
            userId
          };
    }
  }, [imgData, lang, activeSelectIndex, inputText, imgUrl]);

  const identifyingImg = useCallback(
    (param) => {
      setSpinning(true);
      const Dom = document.createElement('IMG');
      Dom.onload = () => {
        setImgDom(Dom);
      };
      Dom.src = lang === 'cn' ? param.answer_url : param.image_url;
      handleIdentifyingImg(param);
    },
    [handleIdentifyingImg, lang]
  );

  const handleUploadImg = (img) => {
    const Dom = document.createElement('IMG');
    Dom.onload = () => {
      setImgDom(Dom);
    };
    Dom.src = img;
    changeLocationInfo([]);
    setImgData(img);
    setFieldsValue({ topic: '' });
    setFieldsValue({ gread: '' });
  };

  const handleSceneSelect = useCallback(() => {
    identifyingImg(params());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const correction = () => {
    if (lang === 'en') return identifyingImg(params());
    validateFields(['topic', 'gread'], (err) => {
      if (!err) {
        identifyingImg(params());
      }
    });
  };

  useEffect(() => {
    handleSceneSelect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (response) {
      setSpinning(false);
    }
  }, [response]);

  return (
    <StyledDemonstration>
      <Spin indicator={antIcon} spinning={spinning}>
        <Row>
          <Col span={14} className="identifying_content">
            <Row>
              {lang === 'cn' && (
                <Col span={24}>
                  <div
                    style={{
                      width: '100%',
                      height: '60px',
                      display: 'flex',
                      alignItems: 'center',
                      background: '#FFF'
                    }}
                  >
                    <Col span={24}>
                      <Form
                        name="control-ref"
                        ref={formCanvas}
                        autoComplete="off"
                      >
                        <Col span={14}>
                          <Form.Item
                            label="作文标题"
                            className="identifying_input"
                          >
                            {inputOption
                              ? getFieldDecorator('topic', {
                                  rules: [
                                    {
                                      required: true,
                                      message: '请输入作文标题'
                                    },
                                    {
                                      max: 20,
                                      pattern: /^[\u4e00-\u9fa5]+$/gi,
                                      message:
                                        '作文标题限制20字以内，且必须是中文'
                                    }
                                  ],
                                  initialValue: inputText,
                                  getValueFromEvent: (event) => {
                                    setInputText(event.target.value);
                                    return event.target.value;
                                  }
                                })(
                                  <Input
                                    style={{ width: '300px' }}
                                    maxLength={20}
                                    placeholder={inputOption.placeHolder}
                                  />
                                )
                              : null}
                          </Form.Item>
                        </Col>
                        <Col
                          span={9}
                          offset={1}
                          className="identifying_select_wrap"
                        >
                          <Form.Item
                            label="年级"
                            className="identifying_select"
                          >
                            {selectList.length > 0
                              ? getFieldDecorator('gread', {
                                  rules: [
                                    {
                                      required: true,
                                      message: '请选择年级'
                                    },
                                    {
                                      validator: (rule, value, callback) => {
                                        if (value && value === '请选择年级') {
                                          callback('请选择年级');
                                        }
                                        callback();
                                      }
                                    }
                                  ],
                                  initialValue: activeSelectIndex,
                                  normalize: (value) => {
                                    if (value === '') {
                                      return '请选择年级';
                                    }
                                    return value;
                                  },
                                  getValueFromEvent: (value) => {
                                    setActiveSelectIndex(value);
                                    return value;
                                  }
                                })(
                                  <Select
                                    placeholder="请选择年级"
                                    style={{ width: '150px' }}
                                  >
                                    {selectList.map((opt) => {
                                      return (
                                        <Option value={opt.key} key={opt.key}>
                                          {opt.label}
                                        </Option>
                                      );
                                    })}
                                  </Select>
                                )
                              : null}
                          </Form.Item>
                        </Col>
                      </Form>
                    </Col>
                  </div>
                </Col>
              )}
              <Col span={24}>
                <CanvasDrawer
                  id="canvas"
                  backgroundImg={imgDom}
                  pointsGroup={location}
                  width="866"
                  height="700"
                  onlineScale={1}
                />
              </Col>
              {!noUpload ? (
                <Row className="identifying_upload">
                  <Col span={19} offset={1}>
                    <small>
                      图片文件类型支持PNG、JPG、JPEG、BMP，图片大小不超过2M
                    </small>
                  </Col>
                  <Col span={3}>
                    <UploadImg2base64 onFileReady={handleUploadImg} />
                  </Col>
                </Row>
              ) : null}
            </Row>
            <Row>
              <Col span={24}>
                <div
                  style={{
                    width: '100%',
                    height: '60px',
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'flex-end'
                  }}
                >
                  <div style={{ width: '99%' }}>
                    <Button
                      type="primary"
                      block
                      size="large"
                      onClick={correction}
                    >
                      批改
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
          <Col span={10} className="identifying_result">
            <Collapse accordion defaultActiveKey="2">
              <Panel header="识别结果" key="1">
                {result}
              </Panel>
              <Panel header="批改结果" key="2">
                {request}
              </Panel>
              <Panel header="Response" key="3">
                <ReactJson src={response} />
              </Panel>
            </Collapse>
          </Col>
        </Row>
      </Spin>
    </StyledDemonstration>
  );
};

OcrCCDemonstration.propTypes = {
  request: PropTypes.node,
  response: PropTypes.object,
  result: PropTypes.node,
  materialsPath: PropTypes.array,
  selectList: PropTypes.array,
  handleIdentifyingImg: PropTypes.func,
  changeLocationInfo: PropTypes.func,
  noUpload: PropTypes.bool,
  inputOption: PropTypes.object,
  initInfo: PropTypes.object,
  location: PropTypes.array
};

OcrCCDemonstration.defaultProps = {
  noUpload: false
};
const OcrCCDemonstrationForm = Form.create({ name: 'normal_login' })(
  OcrCCDemonstration
);
export default OcrCCDemonstrationForm;
